import cooperplaceApi from 'services/apis/cooperplace';

export class ShippingCompanyServiceError extends Error {
  constructor(message, status = null) {
    super(message);
    this.name = 'ShippingCompanyServiceError';
    this.status = status;
  }
}

function getErrorMessage(error, defaultMessage) {
  const data = error?.response?.data;
  if (typeof data?.error === 'string') return data.error;
  if (typeof data?.message === 'string') return data.message;
  if (Array.isArray(data?.errors) && typeof data.errors[0] === 'string') return data.errors[0];
  return defaultMessage;
}

async function request(call, defaultMessage) {
  try {
    const response = await call();
    return response.data;
  } catch (error) {
    throw new ShippingCompanyServiceError(
      getErrorMessage(error, defaultMessage),
      error?.response?.status ?? null,
    );
  }
}

// Cada campo vem null quando o usuário não tem a permissão correspondente.
export function getShippingCompanyCertificateStatus(personId) {
  return request(
    () => cooperplaceApi.get(`persons/shipping-company/${personId}/certificate`),
    'Não foi possível consultar o certificado. Tente novamente.',
  );
}

export function getShippingCompanyCertificateUrl(personId) {
  return request(
    () => cooperplaceApi.get(`persons/shipping-company/${personId}/certificate-url`),
    'Não foi possível obter o certificado.',
  );
}

export function getShippingCompanyCertificatePassword(personId) {
  return request(
    () => cooperplaceApi.get(`persons/shipping-company/${personId}/certificate-password`),
    'Não foi possível descriptografar a senha do certificado.',
  );
}
